module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "padded"
  }, [_vm._m(0), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('el-row', {
    attrs: {
      "gutter": 12,
      "type": "flex"
    }
  }, [(_vm.stats.landlords) ? _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Active Landlord",
      "icon": "fa fa-home",
      "value": _vm.stats.landlords,
      "url": "/property/landlords"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.stats.averageRental) ? _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Avg Rental",
      "icon": "fa fa-money-bill-wave",
      "color": "seagreen",
      "currency": "",
      "value": _vm.stats.averageRental,
      "url": "/property/rentals"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.stats.expiryTenancy) ? _c('el-col', {
    attrs: {
      "align": "center"
    }
  }, [_c('dash-text', {
    attrs: {
      "caption": "Expiring Tenancies",
      "icon": "fa fa-calendar-day",
      "color": "indianred",
      "no-plural": "",
      "value": _vm.stats.expiryTenancy,
      "url": "/property/expiry"
    }
  })], 1) : _vm._e()], 1), _vm._v(" "), (_vm.stats.landlords || _vm.stats.averageRental || _vm.stats.expiryTenancy) ? _c('hr') : _vm._e(), _vm._v(" "), _c('h3', [_vm._v("Expiring Tenancies Calendar")]), _vm._v(" "), _c('p'), _vm._v(" "), _c('events-calendar', {
    attrs: {
      "category": "tenancy"
    }
  }), _vm._v(" "), _c('hr'), _vm._v(" "), _c('property-charts', {
    attrs: {
      "show-details": true
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "dash-heading"
  }, [_c('i', {
    staticClass: "fa fa-globe"
  }), _vm._v(" Property Summary")])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0421aefc"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/views/PropertySummary.vue
// module id = 1394
// module chunks = 0